module.exports = __webpack_public_path__ + "c8543d54defbbfb1ef9c41810635d30f.svg";